export type Endpoints = {
  createManifest: string;
  getAutoPayDetails: string;
  confirmation: string;
  cancelMembershipAutoPay: string;
  getDiscount: string;
};

export enum Environments {
  local = 'local',
  localProxy = 'localProxy',
  dev1 = 'dev1',
  dev2 = 'dev2',
  dev = 'dev',
  qa1 = 'qa1',
  qa2 = 'qa2',
  qa = 'qa',
  uat1 = 'uat1',
  uat2 = 'uat2',
  uat = 'uat',
  stage = 'stg',
  prod = 'prod',
}

const endpointPath = {
  createManifest: '/manifest',
  getAutoPayDetails: '/autopay-details',
  confirmation: '/confirmation',
  cancelMembershipAutoPay: '/cancel-membership-autopay',
  getDiscount: '/discount',
};

export const getEnvironmentFromHost = (hostname: string): Environments => {
  if (hostname.search('localhost') > -1) {
    return Environments.local;
  } else if (hostname.startsWith('autopay.app.ace.aaa.com')) {
    return Environments.localProxy;
  } else {
    if (hostname.startsWith('appdev1') || hostname.startsWith('app.dev')) {
      return Environments.dev;
    } else if (hostname.startsWith('appqa1') || hostname.startsWith('app.qa')) {
      return Environments.qa;
    } else if (hostname.startsWith('appuat1') || hostname.startsWith('app.uat')) {
      return Environments.uat;
    } else if (hostname.startsWith('appstage') || hostname.startsWith('app.stage')) {
      return Environments.stage;
    } else if (hostname.startsWith('app.')) {
      return Environments.prod;
    } else {
      return Environments.dev;
    }
  }
};

export const getApiDomain = (env: Environments): string => {
  if (env === Environments.prod) {
    return `common.api.ace.aaa.com`;
  } else {
    return `common.api.${env}.ace.aaa.com`;
  }
};

export const getEndpoints = (hostname: string): Endpoints => {
  const env = getEnvironmentFromHost(hostname);

  const basePath = 'payments-manage-autopay/manage-autopay/v1';
  const _endpoints: Endpoints = {
    createManifest: `https://${getApiDomain(env)}/${basePath}${endpointPath.createManifest}`,
    getAutoPayDetails: `https://${getApiDomain(env)}/${basePath}${endpointPath.getAutoPayDetails}`,
    confirmation: `https://${getApiDomain(env)}/${basePath}${endpointPath.confirmation}`,
    cancelMembershipAutoPay: `https://${getApiDomain(env)}/${basePath}${endpointPath.cancelMembershipAutoPay}`,
    getDiscount: `https://${getApiDomain(env)}/${basePath}${endpointPath.getDiscount}`,
  };

  return _endpoints;
};

export const endpoints = getEndpoints(window.location.hostname);
